import { render, staticRenderFns } from "./bing.vue?vue&type=template&id=1fa8c2ca&scoped=true&"
import script from "./bing.vue?vue&type=script&lang=js&"
export * from "./bing.vue?vue&type=script&lang=js&"
import style0 from "./bing.vue?vue&type=style&index=0&id=1fa8c2ca&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fa8c2ca",
  null
  
)

export default component.exports